// src/stores/windows/windows.js

const windows = {
    namespaced: true,
    state: () => ({
        initialized: false,
        visible: false,
        component: null,
        payload: null
    }),
    mutations: { 
        INIT(state) 
        {
            state.initialized = true
        },
        OPEN(state, { component, payload = null }) 
        {
            state.component = component
            state.payload = payload
            state.visible = true
        },
        CLOSE(state)
        {
            state.visible = false
            state.component = null
            state.payload = null
        }
    },
    getters: {
        isVisible: (state) => state.visible,

        getComponent: (state) => state.component,
        getPayload: (state) => state.payload
    },
    actions: { 
        init({ commit }) {
            commit('INIT')
        },
        open({ commit }, { component, payload = null }) {
            commit('OPEN', { component, payload })
        },
        close({ commit }) {
            commit('CLOSE')
        }
    }
}

export default windows